export default "__VITE_ASSET__fb1ab0c0__"